import { useEffect, useState } from "react";
import axios from "axios";

const LocationModal = ({ filters, setFilters, onClose }) => {
  const [activeSection, setActiveSection] = useState(null);

  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const [cities, setCities] = useState([]);

  const locationFilter = filters.location || {};
  const [selectedCountry, setSelectedCountry] = useState(locationFilter.country || "");
  const [selectedRegion, setSelectedRegion] = useState(locationFilter.region || "");
  const [cityQuery, setCityQuery] = useState(locationFilter.city || "");

  // Sync local state with filters when they change
  useEffect(() => {
    const loc = filters.location || {};
    setSelectedCountry(loc.country || "");
    setSelectedRegion(loc.region || "");
    setCityQuery(loc.city || "");
  }, [filters.location]);

  /* ------------------ FETCH COUNTRIES ------------------ */
  useEffect(() => {
    axios
      .get("https://countriesnow.space/api/v0.1/countries/positions")
      .then(res => setCountries(res.data.data))
      .catch(err => console.error(err));
  }, []);

  /* ------------------ FETCH REGIONS ------------------ */
  const fetchRegions = async (country) => {
    setSelectedCountry(country);
    setSelectedRegion("");
    setCities([]);
    setFilters({
      ...filters,
      location: { ...locationFilter, country, region: "", city: "" }
    });

    const res = await axios.post(
      "https://countriesnow.space/api/v0.1/countries/states",
      { country }
    );

    setRegions(res.data.data.states || []);
  };

  /* ------------------ FETCH CITIES ------------------ */
  const fetchCities = async (country, state) => {
    setSelectedRegion(state);
    setFilters({
      ...filters,
      location: { ...locationFilter, country, region: state, city: "" }
    });

    const res = await axios.post(
      "https://countriesnow.space/api/v0.1/countries/state/cities",
      { country, state }
    );

    setCities(res.data.data || []);
  };

  const handleCitySelect = (city) => {
    setCityQuery(city);
    setFilters({
      ...filters,
      location: { ...locationFilter, city }
    });
  };

  const toggle = (section) =>
    setActiveSection(prev => (prev === section ? null : section));

  return (
    <div className="w-full relative">
      {/* Arrow Pointer */}
      <div className="absolute -top-5 left-10 w-4 h-4 bg-white rotate-45 border-l border-t"></div>
      <h2 className="lg:text-xl text-lg font-semibold mb-4">Location</h2>

      {/* COUNTRY */}
      <Header title="Filter by Country" open={activeSection === "country"} onClick={() => toggle("country")} />

      {activeSection === "country" && (
        <select
          className="w-full border rounded-xl px-4 py-3 mt-4 lg:text-base text-sm"
          value={selectedCountry}
          onChange={(e) => fetchRegions(e.target.value)}
        >
          <option value="">Select a country</option>
          {countries.map(c => (
            <option key={c.name} value={c.name}>
              {c.name}
            </option>
          ))}
        </select>
      )}

      {/* REGION */}
      <Header title="Filter by Region" open={activeSection === "region"} onClick={() => toggle("region")} />

      {activeSection === "region" && (
        <div className="mt-4 space-y-3">
          <select
            className="w-full border rounded-xl px-4 py-3 lg:text-base text-sm"
            value={selectedCountry}
            onChange={(e) => fetchRegions(e.target.value)}
          >
            <option value="">1. Select Country</option>
            {countries.map(c => (
              <option key={c.name} value={c.name}>
                {c.name}
              </option>
            ))}
          </select>

          <select
            className="w-full border rounded-xl px-4 py-3 lg:text-base text-sm"
            value={selectedRegion}
            onChange={(e) => {
              fetchCities(selectedCountry, e.target.value);
            }}
          >
            <option value="">2. Select Region</option>
            {regions.map(r => (
              <option key={r.name} value={r.name}>
                {r.name}
              </option>
            ))}
          </select>
        </div>
      )}

      {/* CITY */}
      <Header title="Filter by City" open={activeSection === "city"} onClick={() => toggle("city")} />

      {activeSection === "city" && (
        <div className="mt-4">
          <input
            type="text"
            placeholder="Enter first 3 letters"
            className="w-full border rounded-xl px-4 py-3 lg:text-base text-sm"
            value={cityQuery}
            onChange={(e) => setCityQuery(e.target.value)}
          />

          {cityQuery.length >= 3 && (
            <div className="border rounded-xl mt-2 max-h-48 overflow-auto">
              {cities
  .filter(c => c.toLowerCase().includes(cityQuery.toLowerCase()))
  .map(city => (
    <div
      key={city}
      onClick={() => handleCitySelect(city)}
      className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
    >
      {city}
    </div>
))}

            </div>
          )}
        </div>
      )}

      <div className="flex justify-between gap-6 mt-4">
        <button
          onClick={() => {
            setFilters({ ...filters, location: {} });
            setSelectedCountry("");
            setSelectedRegion("");
            setCityQuery("");
            onClose();
          }}
          className="underline text-sm text-gray-700 hover:text-gray-900"
        >
          Clear
        </button>
        <button
          onClick={onClose}
          className="bg-orange-500 text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-orange-600 transition"
        >
          Save
        </button>
      </div>
    </div>
  );
};

/* ---------- UI HEADER ---------- */
const Header = ({ title, open, onClick }) => (
  <div onClick={onClick} className="flex justify-between items-center border-b py-5 cursor-pointer">
    <span className="text-lg">{title}</span>
    <span className="text-2xl">{open ? "✕" : "+"}</span>
  </div>
);

export default LocationModal;



// import countries from "../../data/countries.json";
// const LocationModal = ({ onClose }) => {
//     return (
//       <>
//         <h2 className="text-2xl font-semibold text-center mb-8">Location</h2>
  
//         {["Country", "Region", "City"].map(item => (
//           <div
//             key={item}
//             className="flex justify-between items-center border-b py-5"
//           >
//             <span className="text-lg">Filter by {item}</span>
//             <span className="text-2xl">+</span>
//           </div>
//         ))}
  
//         <button
//           onClick={onClose}
//           className="mt-10 w-full bg-black text-white py-4 rounded-xl text-lg"
//         >
//           Save
//         </button>
//       </>
//     );
//   };
  
//   export default LocationModal;
  